import React, { useContext } from 'react';
import api from './api';
import { useState  } from 'react'

const AppContext = React.createContext();

const AppProvider = ({ children }) => {

    const [successMessagesDefault, successMessageUpdate] = useState('');

    //admin
    const [allUsersMongoData, updateallUsersMongoData] = useState([]);
    const [allUsersWithData, updateAllUsersWithData] = useState([])
    const [allUsersDepData, updateAllUsersDepData] = useState([])
    const [AllUsersTradeData, updateAllUsersTradeData] = useState([])

    //users
    const [allUserMongoData, updateallUserMongoData] = useState([]);
    const [allUserTrade, updateallUserTrade] = useState([]);
    const [allUserDep, updateallUserDep] = useState([]);
    const [allUserWithdraw, updateallUserWithdraw] = useState([]);


    const fetchAdminData = async () => {
      try {
        const adminResponse = await api.get('/api/admin/dashboard');
        const adminData = adminResponse.data.user;
        updateallUsersMongoData(adminData);

        const adminWithResp = await api.get('/api/admin/withdrawals');
        const adminWithData = adminWithResp.data.user;
        updateAllUsersWithData(adminWithData);

        const adminDepResp = await api.get('/api/admin/deposit');
        const adminDepData = adminDepResp.data.user;
        updateAllUsersDepData(adminDepData);

        const adminTradeResp = await api.get('/api/admin/trade');
        const adminTradeData = adminTradeResp.data.user;
        updateAllUsersTradeData(adminTradeData);

      } catch (error) {
        console.log(error)
      }
    }

    const fetchUserData = async () => {
      try {
          const userResponse = await api.get('/api/user/dashboard');
          const userData = userResponse.data.user;
          updateallUserMongoData(userData);

          const usertraderesp = await api.get('/api/user/gettradedata');
          const userTradeData = usertraderesp.data.user;
          updateallUserTrade(userTradeData);

          const userDepositresp = await api.get('/api/user/getdepositdata');
          const userDepData = userDepositresp.data.user;
          updateallUserDep(userDepData);

          const userWithResp = await api.get('/api/user/getwithdrawdata');
          const userWithdATA = userWithResp.data.user;
          updateallUserWithdraw(userWithdATA);

      } catch (error) {
        console.log(error)
      }
    }



    return <AppContext.Provider value={{
      successMessageUpdate,
      successMessagesDefault,
      allUsersMongoData,
      allUsersWithData,
      allUsersDepData,
      fetchAdminData,
      AllUsersTradeData,
      allUserMongoData,
      allUserTrade,
      allUserDep,
      allUserWithdraw,
      fetchUserData
    }}>{children}</AppContext.Provider>;
};

const useGlobalContext = () => {
  return useContext(AppContext);
};

export { useGlobalContext, AppProvider };
